import React, { useState } from 'react';
import styles from './styles.module.less';
import {
  Form,
  Select,
  Radio,
  Row,
  Col,
  Input,
  InputNumber,
  Checkbox,
  Button
} from 'antd';
import tabler_arrows from '@/common/assets/images/tabler_arrows-exchange.svg';
import searchred from '@/common/assets/images/searchred.svg';
import searchwhite from '@/common/assets/images/searchwhite.svg';

const Search = ({
  maritial_Status,
  country_codes,
  city_details,
  state_details,
  education_list,
  family_Status,
  family_Value,
  family_Type,
  department_details,
  currency_data,
  onSubmit,
  searchResult_loading
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [activeTab, setActiveTab] = useState('personal');
  const [selectedField, setSelectedField] = useState('');
  const [hover, setHover] = useState(false);
  const [minAge, setMinAge] = useState(18);
  const [minHeight, setMinHeight] = useState(100);

  const options = [
    'Government/PSU',
    'Private',
    'Business',
    'Defence',
    'Self-Employed',
    'Not Working'
  ];

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        // console.log('Form Data:', values);
        onSubmit(values);
      })
      .catch((error) => {
        console.error('Validation Failed:', error);
      });
  };
  const handleCheckboxChange = (field) => {
    setSelectedField(field);
  };

  return (
    <div className={styles.container}>
      {/* <button className={styles.primaryButton}>Back</button> */}
      <div className={styles.searchOuter}>
        <Form
          form={form}
          onFinish={handleSubmit}
          style={{ fontFamily: 'teachers' }}
        >
          <div className={styles.searchHeader}>
            <h1 className={styles.searchHeaderText}>Search Filter</h1>
            {/* <button
              type="primary"
              htmlType="submit"
              className={styles.searchButton}
              onMouseEnter={() => setHover('enter')}
              onMouseLeave={() => setHover(null)}
              // onClick={handleSubmit}
              loading={searchResult_loading}
            >
              <img
                src={hover === 'enter' ? searchwhite : searchred}
                alt="search"
                style={{ paddingRight: '10px' }}
                className={styles.ManageIcon}
              />{' '}
              Search
            </button> */}
            <Button
              type="primary"
              htmlType="submit"
              className={styles.searchButton}
              onMouseEnter={() => setHover('enter')}
              onMouseLeave={() => setHover(null)}
              onClick={handleSubmit}
              loading={searchResult_loading}
              icon={
                <img
                  src={hover === 'enter' ? searchwhite : searchred}
                  alt="search"
                  style={{ paddingRight: '10px' }}
                  className={styles.ManageIcon}
                />
              }
            >
              Search
            </Button>
          </div>

          <div className={styles.searchContent}>
            <div className={styles.searchTab}>
              {['personal', 'family', 'education'].map((section) => (
                <div
                  key={section}
                  className={`${styles.searchTabHeader} ${
                    activeTab[section] ? styles.activeTab : ''
                  }`}
                  onClick={() =>
                    // handleSectionClick(section)
                    setActiveTab(section)
                  }
                  style={{
                    borderBottom:
                      activeTab === section ? '3px solid #d20b0b' : 'none'
                  }}
                >
                  {section}
                </div>
              ))}
            </div>

            {/** Search Personal  */}
            {/* {openSections.personal && ( */}
            <div
              className={styles.searchPersonal}
              style={{ display: activeTab === 'personal' ? 'block' : 'none' }}
            >
              <div>
                {/** personal one  */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    {/** about Age */}
                    <div style={{ display: 'flex', gap: '9px' }}>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>Age Range</label>
                        <div style={{ display: 'flex', gap: '9px' }}>
                          <div className={styles.selectContainer}>
                            <Form.Item
                              name="minAge"
                              rules={[
                                // {
                                //   required: false,
                                //   message: 'Min age is required'
                                // },
                                {
                                  validator: (_, value) =>
                                    !value || (value >= 18 && value <= 100)
                                      ? Promise.resolve()
                                      : Promise.reject(
                                          new Error(
                                            'Min age must be between 18 and 100'
                                          )
                                        )
                                }
                              ]}
                            >
                              <InputNumber
                                placeholder="Min. Age"
                                min={18}
                                max={100}
                                onChange={(value) => {
                                  setMinAge(value || 18);
                                  const maxAge = form.getFieldValue('maxAge');
                                  if (maxAge < value) {
                                    form.setFieldsValue({
                                      maxAge: value
                                    });
                                  }
                                  form.validateFields(['maxAge']);
                                }}
                              />
                            </Form.Item>
                          </div>
                          <div className={styles.selectContainer}>
                            <Form.Item
                              name="maxAge"
                              dependencies={['minAge']}
                              rules={[
                                // {
                                //   required: false,
                                //   message: 'Max age is required'
                                // },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const minAge = getFieldValue('minAge');
                                    if (!minAge || !value || value >= minAge) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        'Max age must be equal to or greater than Min age'
                                      )
                                    );
                                  }
                                })
                              ]}
                            >
                              <InputNumber
                                placeholder="Max. Age"
                                min={minAge || 18} // ✅ Dynamically update min value
                                max={100}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      {/** about Height */}
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>
                          Height Range(in cm)
                        </label>
                        <div
                          style={{
                            display: 'flex',
                            gap: '9px',
                            width: '100%'
                          }}
                        >
                          <div className={styles.selectContainer}>
                            <Form.Item
                              name="minHeight"
                              rules={[
                                // {
                                //   required: false,
                                //   message: 'Min height is required'
                                // },
                                {
                                  validator: (_, value) =>
                                    !value || (value >= 100 && value <= 250)
                                      ? Promise.resolve()
                                      : Promise.reject(
                                          new Error(
                                            'Min height must be between 100 and 250 cm'
                                          )
                                        )
                                }
                              ]}
                            >
                              <InputNumber
                                placeholder="Min. Height"
                                min={100}
                                max={250}
                                onChange={(value) => {
                                  setMinHeight(value || 100);
                                  const maxHeight =
                                    form.getFieldValue('maxHeight');
                                  if (maxHeight < value) {
                                    form.setFieldsValue({
                                      maxHeight: value
                                    });
                                  }
                                  form.validateFields(['maxHeight']);
                                }}
                              />
                            </Form.Item>
                          </div>
                          <div className={styles.selectContainer}>
                            <Form.Item
                              name="maxHeight"
                              dependencies={['minHeight']}
                              rules={[
                                // {
                                //   required: false,
                                //   message: 'Max height is required'
                                // },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const minHeight =
                                      getFieldValue('minHeight');
                                    if (
                                      !minHeight ||
                                      !value ||
                                      value >= minHeight
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      new Error(
                                        'Max height must be equal to or greater than Min height'
                                      )
                                    );
                                  }
                                })
                              ]}
                            >
                              <InputNumber
                                placeholder="Max. Height"
                                min={minHeight || 100} // ✅ Dynamically update min value
                                max={250}
                                onChange={(value) => {
                                  const maxHeight =
                                    form.getFieldValue('maxHeight');
                                  if (maxHeight < value) {
                                    form.setFieldsValue({
                                      maxHeight: value
                                    });
                                  }
                                  form.validateFields(['maxHeight']);
                                }}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** personal two  */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>
                          Marital Status
                        </label>
                        <div className={styles.personalTwo}>
                          <div className={styles.checkboxOuter}>
                            <div className={styles.checkboxInside}>
                              <Form.Item name="marital_status_id">
                                <Radio.Group
                                  name="marital_status_id"
                                  className={styles.radiobuttons}
                                >
                                  {maritial_Status?.length
                                    ? maritial_Status.map((mstatus) => (
                                        <Radio
                                          key={mstatus.id}
                                          value={mstatus.marital_status}
                                          className={styles.radioInner}
                                        >
                                          {mstatus.marital_status}
                                        </Radio>
                                      ))
                                    : null}
                                </Radio.Group>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/** City, State, Country Selection code  */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>Location</label>
                        <div className={styles.personalTwo1}>
                          <div className={styles.checkboxOuter}>
                            <div className={styles.checkboxInside}>
                              <div className={styles.radiobuttons1}>
                                <Checkbox
                                  checked={selectedField === 'city'}
                                  onChange={() => handleCheckboxChange('city')}
                                >
                                  City
                                </Checkbox>
                                <Checkbox
                                  checked={selectedField === 'state'}
                                  onChange={() => handleCheckboxChange('state')}
                                >
                                  State
                                </Checkbox>
                                <Checkbox
                                  checked={selectedField === 'country'}
                                  onChange={() =>
                                    handleCheckboxChange('country')
                                  }
                                >
                                  Country
                                </Checkbox>
                              </div>
                              {/* </Form.Item> */}
                            </div>
                          </div>

                          <div
                            style={{
                              display:
                                selectedField === 'country' ? 'block' : 'none'
                            }}
                          >
                            <div className={styles.formColumn}>
                              <label className={styles.ageLabel}>Country</label>
                              <Form.Item name="personal_country">
                                <Select
                                  mode="multiple"
                                  placeholder="Select Country"
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(value) =>
                                    form.setFieldsValue({
                                      personal_country: value
                                    })
                                  }
                                >
                                  {country_codes?.map((code, index) => (
                                    <Option value={code?.country} key={index}>
                                      {code?.country}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>

                          <div
                            style={{
                              display:
                                selectedField === 'state' ? 'block' : 'none'
                            }}
                          >
                            <div className={styles.formColumn}>
                              <label className={styles.ageLabel}>State</label>
                              <Form.Item name="personal_state">
                                <Select
                                  mode="multiple"
                                  placeholder="Select State"
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(value) =>
                                    form.setFieldsValue({
                                      personal_state: value
                                    })
                                  }
                                >
                                  {state_details?.map((state, index) => (
                                    <Option value={state?.state} key={index}>
                                      {state?.state}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>

                          <div
                            style={{
                              display:
                                selectedField === 'city' ? 'block' : 'none'
                            }}
                          >
                            <div className={styles.formColumn}>
                              <label className={styles.ageLabel}>City</label>
                              <Form.Item name="personal_city">
                                <Select
                                  className={styles.customSelectHob}
                                  mode="multiple"
                                  placeholder="Select City"
                                  showSearch
                                  showArrow={true}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  onChange={(value) =>
                                    form.setFieldsValue({
                                      personal_city: value
                                    })
                                  }
                                >
                                  {city_details?.map((city, index) => (
                                    <Option value={city?.city} key={index}>
                                      {city?.city}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}

            {/** Search Family */}
            {/* {openSections.family && ( */}
            <div
              className={styles.searchPersonal}
              style={{ display: activeTab === 'family' ? 'block' : 'none' }}
            >
              <div>
                {/** family one details */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    {/**  mother education */}
                    <div style={{ display: 'flex', gap: '9px' }}>
                      <div className={styles.countryRangeContainer}>
                        <label className={styles.ageLabel}>
                          Mother&apos;s Education
                        </label>
                        <div>
                          <div className={styles.selectContainerCountry}>
                            <Form.Item
                              name="desired_partner_mother_education"
                              // label="Highest Education"
                              className={styles.sectionTitle}
                            >
                              <Select
                                placeholder="Select a Degree"
                                className={styles.select}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) =>
                                  form.setFieldsValue({
                                    desired_partner_mother_education: value
                                  })
                                }
                              >
                                {education_list?.length
                                  ? education_list?.map((list, index) => {
                                      return (
                                        <option
                                          value={list?.higher_education}
                                          key={index}
                                        >
                                          {list?.higher_education}
                                        </option>
                                      );
                                    })
                                  : ''}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>

                      {/** father education */}
                      <div className={styles.countryRangeContainer}>
                        <label className={styles.ageLabel}>
                          Father&apos;s Education
                        </label>
                        <div>
                          <div className={styles.selectContainerCountry}>
                            <Form.Item
                              name="desired_partner_father_education"
                              // label="Highest Education"
                              className={styles.sectionTitle}
                            >
                              <Select
                                placeholder="Select a Degree"
                                className={styles.select}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) =>
                                  form.setFieldsValue({
                                    desired_partner_father_education: value
                                  })
                                }
                              >
                                {education_list?.length
                                  ? education_list?.map((list, index) => {
                                      return (
                                        <option
                                          value={list?.higher_education}
                                          key={index}
                                        >
                                          {list?.higher_education}
                                        </option>
                                      );
                                    })
                                  : ''}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      {/** about Family type */}
                      <div className={styles.countryRangeContainer}>
                        <label className={styles.ageLabel}>Family Type</label>
                        <div>
                          <div className={styles.selectContainerCountry}>
                            <div className={styles.checkboxFamily1}>
                              <div className={styles.familyInner}>
                                <Form.Item
                                  // label="Family Type"
                                  name="family_type_id"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select family type'
                                    }
                                  ]}
                                >
                                  <div
                                    className={styles.selectContainerCountry}
                                  >
                                    <div className={styles.checkboxFamily}>
                                      <div className={styles.familyInner}>
                                        <Radio.Group>
                                          <Row
                                            gutter={[24]}
                                            className={styles.radiobuttons}
                                          >
                                            {family_Type?.length
                                              ? family_Type.map(
                                                  (ftype, index) => (
                                                    <Col span={6} key={index}>
                                                      <Radio value={ftype.type}>
                                                        {ftype.type}
                                                      </Radio>
                                                    </Col>
                                                  )
                                                )
                                              : null}
                                          </Row>
                                        </Radio.Group>
                                      </div>
                                    </div>
                                  </div>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** family two details */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>Family Status</label>
                        <div className={styles.personalTwo}>
                          <div className={styles.checkboxOuter}>
                            <div className={styles.checkboxInside}>
                              <Form.Item
                                // label="Family Status"
                                name="family_status_id"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please select family status'
                                  }
                                ]}
                              >
                                <Radio.Group>
                                  <Row
                                    gutter={[24]}
                                    className={styles.radiobuttons}
                                  >
                                    {family_Status?.length
                                      ? family_Status.map((fstatus, index) => (
                                          <Col span={6} key={index}>
                                            <Radio value={fstatus.status}>
                                              {fstatus.status}
                                            </Radio>
                                          </Col>
                                        ))
                                      : null}
                                  </Row>
                                </Radio.Group>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** family three details */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>Family Values</label>
                        <div className={styles.personalTwo}>
                          <div className={styles.checkboxOuter}>
                            <div className={styles.checkboxInside}>
                              <Form.Item
                                // label="Family Values"
                                name="family_values_id"
                                rules={[
                                  {
                                    required: false,
                                    message: 'Please select family values'
                                  }
                                ]}
                              >
                                <Radio.Group>
                                  <Row
                                    gutter={[24]}
                                    className={styles.radiobuttons}
                                  >
                                    {family_Value?.length
                                      ? family_Value.map((fvalue, index) => (
                                          <Col span={6} key={index}>
                                            <Radio value={fvalue.values}>
                                              {fvalue.values}
                                            </Radio>
                                          </Col>
                                        ))
                                      : null}
                                  </Row>
                                </Radio.Group>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}
            {/**search Education */}
            {/* {openSections.education && ( */}
            <div
              className={styles.searchPersonal}
              style={{ display: activeTab === 'education' ? 'block' : 'none' }}
            >
              <div>
                {/** education one */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div className={styles.countryRangeContainer}>
                      <label className={styles.ageLabel}>Education</label>
                      <div>
                        <div className={styles.selectContainerCountry}>
                          <Form.Item
                            name="highestEducation"
                            className={styles.sectionTitle}
                          >
                            <Select
                              placeholder="Select a Degree"
                              className={styles.select}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              onChange={(value) =>
                                form.setFieldsValue({ highestEducation: value })
                              }
                            >
                              {education_list?.length
                                ? education_list?.map((list, index) => {
                                    return (
                                      <option
                                        value={list?.higher_education}
                                        key={index}
                                      >
                                        {list?.higher_education}
                                      </option>
                                    );
                                  })
                                : ''}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/** education two  */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    <div>
                      <div className={styles.ageRangeContainer}>
                        <label className={styles.ageLabel}>Employed In</label>
                        <div className={styles.personalThree}>
                          <div className={styles.checkboxOuter}>
                            <div className={styles.checkboxInsideEducation}>
                              <Form.Item
                                name="employmentType"
                                // label="Employed in"
                                className={styles.employedTitle}
                              >
                                <Radio.Group
                                  options={options}
                                  className={styles.checkboxGroup}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** education three  */}
                <div className={styles.personalOne}>
                  <div className={styles.personalCol}>
                    {/** country */}
                    <div style={{ display: 'flex', gap: '9px' }}>
                      <div className={styles.countryRangeContainer}>
                        <label className={styles.ageLabel}>
                          Department / Sector
                        </label>
                        <div>
                          <div className={styles.selectContainerCountry}>
                            <Form.Item
                              name="department"
                              // label="Department / Sector"
                            >
                              <Select
                                placeholder="Select Field of Work"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) =>
                                  form.setFieldsValue({ department: value })
                                }
                              >
                                {department_details?.length
                                  ? department_details?.map(
                                      (department, index) => {
                                        return (
                                          <option
                                            value={department?.department}
                                            key={index}
                                          >
                                            {department?.department}
                                          </option>
                                        );
                                      }
                                    )
                                  : ''}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className={styles.countryRangeContainer}>
                        <label className={styles.ageLabel}>Income Range</label>
                        <div className={styles.selectContainerCountry}>
                          <Form.Item
                            rules={[
                              {
                                required: false,
                                message: 'Please select a currency'
                              }
                            ]}
                            className={styles.fullWidthItem}
                          >
                            <Input.Group
                              compact
                              className={styles.customInputContainer}
                            >
                              {/* Currency Dropdown */}
                              <Form.Item name="currency" noStyle>
                                <Select
                                  style={{ width: '20%' }}
                                  showSearch
                                  placeholder="Currency"
                                  className="custom-select"
                                  optionFilterProp="children"
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                  dropdownStyle={{ borderRadius: '8px' }}
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {currency_data?.length
                                    ? currency_data?.map((cdata, index) => (
                                        <Select.Option
                                          value={cdata?.id}
                                          key={index}
                                        >
                                          {cdata?.currency_code}
                                        </Select.Option>
                                      ))
                                    : ''}
                                </Select>
                                <span className={styles.divider}>|</span>
                              </Form.Item>
                              {/* Min Income Input */}
                              <Form.Item name="min_income" noStyle>
                                <Input
                                  placeholder="Min Income"
                                  type="number"
                                  maxLength={15}
                                  style={{
                                    width: '36%',
                                    borderRightWidth: 0,
                                    borderLeftWidth: 0
                                  }}
                                />
                              </Form.Item>
                              {/* {' '} */}
                              {/* <span className={styles.divider}>-</span>{' '} */}
                              {/* Divider between min & max */}
                              {/* Max Income Input */}
                              <span className={styles.arrowIcon}>
                                {/* <tabler_arrows /> */}
                                <img src={tabler_arrows} alt="Arrow Icon" />
                              </span>
                              <Form.Item
                                name="max_income"
                                noStyle
                                dependencies={['min_income']}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      const minIncome =
                                        getFieldValue('min_income');

                                      if (!value) {
                                        return Promise.resolve(); // No validation if max_income is empty
                                      }

                                      if (
                                        minIncome &&
                                        Number(value) <= Number(minIncome)
                                      ) {
                                        return Promise.reject(
                                          'Max income must be greater than Min income'
                                        );
                                      }

                                      return Promise.resolve();
                                    }
                                  })
                                ]}
                              >
                                <Input
                                  placeholder="Max Income"
                                  type="number"
                                  maxLength={15}
                                  className={styles.maxIncomeInput}
                                  style={{ width: '36%' }}
                                />
                              </Form.Item>
                            </Input.Group>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )} */}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Search;
